class LocationHelper {
    constructor(location) {
        this.location = location
    }

    name = () => `${this.location.address_line_one} ${this.location.address_line_two} ${this.location.city} ${this.location.county} ${this.location.state}`
}

export default LocationHelper